export default __webpack_public_path__ + "static/media/twilloPassIcon.11d7ad54.png";